import _objectDestructuringEmpty from "@babel/runtime/helpers/objectDestructuringEmpty";
import React from 'react';
import { RecommendationBar } from '../../../components/Shared';
import { NewsletterCitingSection } from '../../../components/citing/NewsletterCiting';
import { ContributorSection } from '../../../components/ContributorSection';
import { NewsletterContributorFunctions } from '../constants';
import { MoreOptionsSection } from '../../../components/MoreOptions';
var NoneForm = function NoneForm(_ref) {
  _objectDestructuringEmpty(_ref);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(RecommendationBar, null), /*#__PURE__*/React.createElement(NewsletterCitingSection, null), /*#__PURE__*/React.createElement(ContributorSection, {
    functionOptions: NewsletterContributorFunctions
  }), /*#__PURE__*/React.createElement(MoreOptionsSection, null));
};
export default NoneForm;